import { FC, ReactElement } from 'react';

import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import { Typography } from '@mui/material';

import ZendeskLoader from './ZendeskLoader';

const ZendeskButton: FC<{ iconOnly?: boolean }> = ({ iconOnly = false }) => {
  const icon = <ChatBubbleOutlineIcon color="primary" />;

  const generateUI = (icon: ReactElement): ReactElement => {
    if (iconOnly) return icon;
    return (
      <Typography
        color="primary.dark"
        css={{ display: 'flex', alignItems: 'center' }}
      >
        <span css={{ marginRight: '0.5rem' }}>SUPPORT</span> {icon}
      </Typography>
    );
  };

  return (
    <ZendeskLoader
      loadingIndicator={generateUI(
        <Typography variant="body1">Loading...</Typography>,
      )}
    >
      {generateUI(icon)}
    </ZendeskLoader>
  );
};

export default ZendeskButton;
